import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { CircularProgress } from '@material-ui/core';
export function renderOcrIngestionDocs({
	ocrIngestionDocuments,
	ocrGuideMap,
	ignoreGroups,
	ingestionHasErrored,
}) {
	let lastGroupNumber = 0;
	return (
		<div>
			{ocrIngestionDocuments.map((ocrIngestionDocument, index) => {
				if (!ocrIngestionDocument) {
					return <div key={index}>Missing document #{index}</div>;
				}

				const {
					ocrIngestionDocumentId,
					pageNumber,
					ingestionStatus,
					ingestionStatusMessage,
					matchedOcrGuideId,
					groupNumber,
					extractedData,
				} = ocrIngestionDocument;

				let docName;
				let documentCategory;

				if (extractedData && extractedData.documentCategory) {
					documentCategory = extractedData.documentCategory;
				} else {
					if (matchedOcrGuideId) {
						const ocrGuide = ocrGuideMap[matchedOcrGuideId] || {};
						documentCategory = ocrGuide.documentCategory;
					}
				}
				const documentType = extractedData && extractedData.documentType;
				// Detected but not used for processing — labeled and shown in gray
				const isVeederReceipt = documentCategory === 'veederReceipt';
				const isSuperiorExtraScannedTicket = documentType === 'superiorExtraScannedTicket';

				if (documentCategory === 'carrierDeliveryTicket') {
					docName = 'Carrier Ticket';
				} else if (documentCategory === 'stationDeliveryPickupBol') {
					docName = 'Station Pickup BOL';
				} else if (documentCategory === 'offloadBol') {
					docName = 'Offload BOL';
				} else if (documentCategory === 'pickupBol') {
					docName = 'Pickup BOL';
				} else if (isVeederReceipt) {
					docName = 'Veeder Receipt';
				} else if (isSuperiorExtraScannedTicket) {
					docName = 'Dupe Scanned Carrier Ticket';
				} else {
					docName = '?';
				}

				let style = {};
				if (lastGroupNumber !== groupNumber && !ignoreGroups) {
					lastGroupNumber = groupNumber;
					style = { marginTop: 5, paddingTop: 5, borderTop: '1px solid #a9d7fb' };
				}

				if (ingestionStatus === 'matched' && (isVeederReceipt || isSuperiorExtraScannedTicket)) {
					// Detected but not used for processing — show in gray
					return (
						<div key={ocrIngestionDocumentId} style={{ ...style, color: '#888' }}>
							<span style={{ display: 'inline-block', width: '15px' }}>✓</span>
							<span>
								Page {pageNumber}: {docName}
							</span>
						</div>
					);
				} else if (ingestionStatus === 'matched') {
					return (
						<div key={ocrIngestionDocumentId} style={style}>
							<span style={{ color: 'green', display: 'inline-block', width: '15px' }}>✓</span>
							<span>
								Page {pageNumber}: {docName}
							</span>
						</div>
					);
				} else if (ingestionStatus === 'missingData') {
					style.color = '#444';
					return (
						<div key={ocrIngestionDocumentId} style={style}>
							<span style={{ display: 'inline-block', color: 'red', width: '15px' }}>x</span>
							<span>
								Page {pageNumber}: {docName} : Missing Data
							</span>
						</div>
					);
				} else if (ingestionStatus === 'noMatch') {
					return (
						<div key={ocrIngestionDocumentId} style={{ color: '#555' }}>
							<span style={{ display: 'inline-block', width: '15px' }}>?</span>
							<span>
								Page {pageNumber}: {_.startCase(ingestionStatus)}
							</span>
						</div>
					);
				} else if (ingestionStatus === 'duplicate') {
					return (
						<div key={ocrIngestionDocumentId} style={{ color: '#888' }}>
							<span style={{ display: 'inline-block', width: '15px' }}>-</span>
							<span>
								Page {pageNumber}: {docName} {_.startCase(ingestionStatus)}
							</span>
						</div>
					);
				} else if (ingestionStatus === 'possibleMissRead') {
					return (
						<div key={ocrIngestionDocumentId} style={{ color: '#888' }}>
							<span style={{ display: 'inline-block', width: '15px' }}>-</span>
							<span>
								Page {pageNumber}: {docName} : {_.startCase(ingestionStatus)}
							</span>
						</div>
					);
				} else if (ingestionStatus === 'error') {
					return (
						<div key={ocrIngestionDocumentId} style={{ ...style, color: '#555' }}>
							<div>
								<span style={{ display: 'inline-block', color: 'red', width: '15px' }}>x</span>
								<span>
									Page {pageNumber}: {docName} {_.startCase(ingestionStatus)}
								</span>
							</div>
							<div style={{ paddingLeft: 15, color: '#777', maxWidth: '300px' }}>
								{ingestionStatusMessage}
							</div>
						</div>
					);
				} else {
					style.color = '#444';
					return (
						<div key={ocrIngestionDocumentId} style={style}>
							<span style={{ display: 'inline-block', width: '15px' }}>
								{ingestionHasErrored ? (
									<span style={{ color: 'red' }}>✗</span>
								) : (
									<CircularProgress size="13px" style={{ marginRight: 4 }} />
								)}
							</span>
							<span>
								Page {pageNumber}: {_.startCase(ingestionStatus)}
							</span>
						</div>
					);
				}
			})}
		</div>
	);
}

renderOcrIngestionDocs.propTypes = {
	ocrIngestionDocuments: PropTypes.array.isRequired,
	ocrGuideMap: PropTypes.object.isRequired,
	ignoreGroups: PropTypes.bool,
	ingestionHasErrored: PropTypes.bool,
};
